module.exports = __webpack_public_path__ + "static/media/logo-televisa-black.6caf1143.svg";